{
  "name": "shadcn-vue",
  "type": "module",
  "version": "2.2.0",
  "description": "Add components to your apps.",
  "publishConfig": {
    "access": "public"
  },
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "https://github.com/unovue/shadcn-vue.git",
    "directory": "packages/cli"
  },
  "keywords": [
    "components",
    "ui",
    "vue",
    "nuxt",
    "tailwind",
    "radix-ui",
    "radix-vue",
    "reka-ui",
    "shadcn",
    "shadcn-vue"
  ],
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "default": "./dist/index.js"
    },
    "./registry": {
      "types": "./dist/registry/index.d.ts",
      "default": "./dist/registry/index.js"
    }
  },
  "bin": "./dist/index.js",
  "files": [
    "dist"
  ],
  "scripts": {
    "dev": "tsdown --watch",
    "build": "tsdown",
    "typecheck": "tsc --noEmit",
    "clean": "node ./scripts/rimraf.js",
    "lint": "eslint .",
    "lint:fix": "eslint --fix .",
    "start:dev": "REGISTRY_URL=http://localhost:5173/r node dist/index.js",
    "start": "node dist/index.js",
    "release": "changeset version",
    "pub:beta": "pnpm build && pnpm publish --no-git-checks --access public --tag beta",
    "pub:next": "pnpm build && pnpm publish --no-git-checks --access public --tag next",
    "pub:release": "pnpm build && pnpm publish  --no-git-checks --access public",
    "test": "vitest run",
    "test:update": "vitest run -u",
    "test:ui": "vitest --ui"
  },
  "dependencies": {
    "@unovue/detypes": "^0.8.5",
    "@vue/compiler-sfc": "^3.5",
    "commander": "^14.0.0",
    "consola": "^3.4.2",
    "cosmiconfig": "^9.0.0",
    "deepmerge": "^4.3.1",
    "diff": "^8.0.2",
    "fs-extra": "^11.3.0",
    "get-tsconfig": "^4.10.1",
    "magic-string": "^0.30.17",
    "nypm": "^0.6.0",
    "ofetch": "^1.4.1",
    "ora": "^8.2.0",
    "pathe": "^2.0.3",
    "postcss": "^8.5.3",
    "prompts": "^2.4.2",
    "reka-ui": "catalog:",
    "stringify-object": "^5.0.0",
    "tailwindcss": "^4.1.7",
    "tinyexec": "^1.0.1",
    "tinyglobby": "catalog:",
    "ts-morph": "^26.0.0",
    "undici": "^7.10.0",
    "vue-metamorph": "^3.3.3",
    "zod": "catalog:"
  },
  "devDependencies": {
    "@types/diff": "^8.0.0",
    "@types/fs-extra": "^11.0.4",
    "@types/node": "^22.15.21",
    "@types/prompts": "^2.4.9",
    "@types/stringify-object": "^4.0.5",
    "msw": "^2.8.4",
    "tsdown": "^0.12.3",
    "type-fest": "^4.41.0",
    "typescript": "catalog:"
  }
}
